<template>
  <div class="home_footer bgColor">
    <div class="footer_box bgColor">
      <ul class=" home_footer_titleListTwo">
        <li class="itemLink" :style="{ width: itemWidth }" v-for="(item, index) in $common.listSort($common.getDictionarys(
          'friendlyLinksList',
          dictionarys
        ), 'sort', 2)" :key="index">
          <div class="itemLink_h" @click.stop="itemClick(item)">
            <span class="itemLink_label"> {{ item.label }}</span>
            <i v-show="item.value !== linkType" style="font-size: 16px" class="iconfont icon-down wordColor"></i>
            <i v-show="item.value === linkType" style="font-size: 16px" class="iconfont icon-up wordColor"></i>
          </div>
          <div class="itemLink_list borderColor" v-show="item.value === linkType">
            <div class="itemLink_item" v-for="(i, x) in dataList" :key="i">
              <a style="display: block;" :href="i.url" target="_blank">
                <span class="contentList_text">{{ i.name }}</span>
              </a>
            </div>
          </div>
        </li>
      </ul>

      <div class="footerBox" v-if="$commonData.data.footerData">
        <a :href="$commonData.data.footerData.partyOrgan"
          :class="$commonData.data.footerData.partyOrgan ? '' : 'pointerEvents'" target="_blank">
          <img style="width: 80px;" src="https://dcs.conac.cn/image/red.png" alt="">
        </a>
        <div class="footerBox_right">
          <p class="footerBox_line">
            <span>
              主办单位：{{ $commonData.data.footerData.organizer }}
            </span>
            <span>
              地址：{{ $commonData.data.footerData.address }}
            </span>
            <span v-if="$commonData.data.footerData.phone">电话：{{ $commonData.data.footerData.phone }}</span>
            <span>
              邮编：{{ $commonData.data.footerData.zipCode }}
            </span>
          </p>
          <p class="footerBox_line">
            <span v-if="$commonData.data.footerData.technicalSupport">技术支持：{{
              $commonData.data.footerData.technicalSupport }}</span>
            <a target="_blank" :href="$commonData.data.footerData.icpHttp">ICP备案号：{{ $commonData.data.footerData.icpText
            }}</a>
            <a style="display: flex;align-items: center;" :href="$commonData.data.footerData.publicSecurityHttp"
              target="_blank" v-if="$commonData.data.footerData.publicSecurityText">
              <img style="width: 18px;margin-right: 8px;" :src="global.imageUrl + '/gaba.png'" alt="">
              <span>{{ $commonData.data.footerData.publicSecurityText }}</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import global from '@/assets/js/global.js'
export default {
  name: 'home-footer',
  props: ['dictionarys'],
  data() {
    return {
      global: global,
      linkType: '',
      dataList: [],
      friendlyLinksData: []
    }
  },
  computed: {
    itemWidth() {
      let n = 0
      let arr = this.$common.getDictionarys(
        'friendlyLinksList',
        this.dictionarys
      )
      if (arr && arr.length) {
        n = arr.length
      }
      return (1200 / n - 10) + 'px'
    }
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    window.removeEventListener("click", this.closeDropdown);
  },
  created() {
  },
  methods: {
    itemClick(e) {
      if (this.linkType === e.value) {
        this.linkType = ''
        return
      }
      this.linkType = e.value
      this.dataFn(this.friendlyLinksData)
    },
    closeDropdown() {
      this.linkType = '';
    },
    dataFn(list) {
      this.friendlyLinksData = list
      this.dataList = this.friendlyLinksData.filter((item) => {
        return item.type === this.linkType
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home_footer {
  color: #f0f0f0;

  // padding: 10px 20px;
  .pointerEvents {
    pointer-events: none;
  }

  .footer_box {
    margin: 0 auto;
    width: 1200px;

    .home_footer_label {
      display: flex;
      align-items: center;
      font-size: 22px;
      border-bottom: 2px solid #f0f0f0;
      padding: 15px;
    }

    .home_footer_titleListTwo {
      display: flex;
      justify-content: space-around;

      .itemLink {
        padding: 20px 0;

        .itemLink_h {
          background-color: #fff;
          padding: 2px 10px;
          color: #000;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          border: 1px solid #ccc;

          &:hover {
            opacity: 0.8;
          }
        }

        .itemLink_list {
          background-color: #fff;
          border-top: 2px solid;
          overflow: auto;
          height: 300px;

          .itemLink_item {
            padding: 5px 10px;
            border-bottom: 1px solid #f9f9f9;
            cursor: pointer;
            font-size: 14px;

            &:hover {
              background-color: #f0f0f0;
            }
          }
        }
      }
    }

    .home_footer_titleList {
      display: flex;
      align-items: center;
      height: 60px;
      font-size: 18px;
      padding: 0 15px;



      .titleList_item {
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        position: relative;
        margin-right: 80px;

        .titleList_item_label {
          cursor: pointer;
        }

        .titleList_item_label:hover {
          opacity: 0.7;
        }

        .titleList_item_underline {
          width: 64px;
          height: 4px;
          background: #fff;
          position: absolute;
          bottom: 6px;
          border-radius: 10px
        }
      }

    }

    .contentListBox {
      // min-height: 96px;
      padding: 0 15px;

      .home_footer_contentList {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 10px 0;

        .contentList_item {
          margin-right: 29px;
          margin-bottom: 15px;

          .contentList_text {
            color: #fff;
            cursor: pointer;
          }

          .contentList_text:hover {
            opacity: 0.7;
          }
        }
      }
    }

    .footerBox {
      display: flex;
      align-items: center;

      .footerBox_right {

        .footerBox_line {
          display: flex;
          align-items: center;
          padding-bottom: 5px;
          color: #fff;

          span,
          a {
            padding-right: 20px;
            color: #fff;
          }

          .footerBox_line_home {
            cursor: pointer;
          }

          .footerBox_line_home:hover {
            opacity: 0.8;
          }
        }
      }
    }


  }
}
</style>
